import { AgencyService } from './../api/agency.service';
import { Component, OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service, Reason } from '../models/index';
import { OpenModalService } from './shared/modals/open-modal.service';
import { BaseComponent } from './base-component';

@Component({
  selector: 'app-services-base',
  template: ''
})

export class ServicesBaseComponent extends BaseComponent implements OnInit {
  services: Service[];
  reasons: Reason[] = [];

  constructor(
    injector: Injector,
    public agencyService: AgencyService,
    public route: ActivatedRoute,
    private openModalService: OpenModalService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.route.data.forEach((data: { services: Service[] }) => {
      this.validateRouteDataParams(data, ['services']);
      this.services = data.services;
    });

    this.route.data.forEach((data: { reasons: Reason[] }) => {
      this.validateRouteDataParams(data, ['reasons']);
      this.reasons = data.reasons;
    });

    this.setTitle('Servicii ' + this.agencyService.agency.name);
  }

  openServiceModal(service: Service): void {
    this.openModalService.showDetailsModal(service.name, undefined, service.description, service.image);
  }

  openReasonModal(reason: Reason): void {
    this.openModalService.showDetailsModal(reason.name, undefined, reason.description, reason.image);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/services-base.component.ts